import { render, staticRenderFns } from "./improtPoint.vue?vue&type=template&id=737cca2a&scoped=true&"
import script from "./improtPoint.vue?vue&type=script&lang=js&"
export * from "./improtPoint.vue?vue&type=script&lang=js&"
import style0 from "./improtPoint.vue?vue&type=style&index=0&id=737cca2a&scoped=true&lang=scss&"
import style1 from "./improtPoint.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737cca2a",
  null
  
)

export default component.exports